import React, { useState, useEffect } from "react";
import ScrollAnimation from "react-animate-on-scroll";
import { Gallery } from "../components/gallery";
import Footer from "../components/Footer";
import Label from "../components/Label";
import JSONData from "../data/data.json";

let line = [];
let gall = [];
function SoftwareDevelopment(props) {
  const [myData, setMyData] = useState([]);
  const [gallery, setGallery] = useState();

  const setLinesFunction = () => {
    for (let i = 0; i < JSONData.Services.length; i++) {
      if (JSONData.Services[i].link == "/softwareDevelopment") {
        for (let j = 0; j < JSONData.Services[i].lines.length; j++) {
          line.push(JSONData.Services[i].lines[j]);
        }
      }
    }
    for (let i = 0; i < JSONData.Gallery.length; i++) {
      if (JSONData.Gallery[i].nature == "Software") {
        gall.push(JSONData.Gallery[i]);
      }
    }
    const g = JSONData.Gallery.slice(0, 4);
    setGallery(g);
    const l = line.slice(0, 7);
    setMyData(l);
  };

  useEffect(() => {
    setLinesFunction();
  }, []);
  return (
    <>
      <header id="header">
        <div className="intro">
          <div className="overlay">
            <div className="container">
              <div className="row">
                <div
                  className="col-md-8 col-md-offset-2 intro-text"
                  style={{ marginBottom: -100 }}
                >
                  <ScrollAnimation animateIn="fadeInLeft" delay={0.5 * 1000}>
                    <h1 style={{ fontFamily: "Audiowide", color: "orange" }}>
                      Software Development
                      <span></span>
                    </h1>
                  </ScrollAnimation>
                  <ScrollAnimation animateIn="fadeInRight" delay={0.9 * 1000}>
                    <p style={{ fontFamily: "monospace" }}>
                      Conceiving, specifying, designing, programming,
                      documenting, testing, and bug fixing involved in creating
                      the applications. Changing, modifying, and updating
                      software to keep up with customer needs. Improving
                      performance, and more.
                    </p>
                  </ScrollAnimation>
                  <a
                    href="#features"
                    className="btn btn-custom btn-lg page-scroll"
                  >
                    Learn More
                  </a>
                  <Label />
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <div id="about">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-md-6">
              <ScrollAnimation animateIn="fadeInLeft">
                <img
                  src="./img/Services/about.png"
                  className="img-responsive"
                  alt=""
                />
              </ScrollAnimation>
            </div>

            <div className="col-xs-12 col-md-6">
              <div className="about-text">
                <h2
                  style={{
                    fontSize: 20,
                    fontFamily: "audiowide",
                    color: "orange",
                  }}
                >
                  Zippylink Software Solutions
                </h2>
                <ScrollAnimation animateIn="fadeInRight" delay={0.6 * 1000}>
                  <h3>What We Provide?</h3>
                  {myData.map((item) => {
                    return <p>{item ? item : "loading..."}</p>;
                  })}
                </ScrollAnimation>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Gallery data={gallery} />
      <Footer />
    </>
  );
}

export default SoftwareDevelopment;
